import script from "./Viewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./Viewer.vue?vue&type=script&setup=true&lang=ts"

import "./Viewer.vue?vue&type=style&index=0&id=229fc3fe&scoped=true&lang=css"

import exportComponent from "/home/runner/work/uup/uup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-229fc3fe"]])

export default __exports__